// extracted by mini-css-extract-plugin
export default {"imgContain":"TP","content":"UP","titleAndImage":"VP","title":"WP","text":"XP","rhodeTitle":"YP","shortHR":"ZP","modal_root":"aQ","x_mark":"bQ","flavorStickModal":"cQ","greenBox":"eQ"};
    if(module.hot) {
      // 1730991509040
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  